var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.946029 7H0C0.000127678 5.54662 0.452597 4.12931 1.29463 2.94471C2.13667 1.7601 3.32652 0.866939 4.69912 0.389131C6.07171 -0.0886766 7.55899 -0.127438 8.9546 0.278225C10.3502 0.683888 11.585 1.51386 12.4876 2.653V1.60763H13.4336V4.91874H10.1225V3.97271H12.2438C11.7119 3.05278 10.9475 2.28885 10.0273 1.75752C9.10702 1.22618 8.06324 0.946123 7.00061 0.945414C3.66208 0.945414 0.946029 3.66146 0.946029 7ZM13.0552 7C13.0552 10.3385 10.3392 13.0546 7.00061 13.0546C5.93798 13.0539 4.89421 12.7738 3.97396 12.2425C3.0537 11.7112 2.2893 10.9472 1.75741 10.0273H3.87872V9.08126H0.567617V12.3924H1.51365V11.347C2.41624 12.4861 3.65101 13.3161 5.04662 13.7218C6.44224 14.1274 7.92952 14.0887 9.30211 13.6109C10.6747 13.1331 11.8646 12.2399 12.7066 11.0553C13.5486 9.87069 14.0011 8.45338 14.0012 7H13.0552Z",
    fill: "#FF0000",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.defa12e0.svg";
export { ForwardRef as ReactComponent };